var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeEditorResize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19999 11.6C9.83651 11.6 10.447 11.3472 10.897 10.8971C11.3471 10.447 11.6 9.83656 11.6 9.20004L11.6 2.80004C11.6 2.16352 11.3471 1.55307 10.897 1.10298C10.447 0.652892 9.83651 0.400037 9.19999 0.400037L2.79999 0.400037C2.16347 0.400037 1.55302 0.652892 1.10293 1.10298C0.652846 1.55307 0.399991 2.16352 0.399991 2.80004L0.399991 9.20004C0.399991 9.83656 0.652846 10.447 1.10293 10.8971C1.55302 11.3472 2.16347 11.6 2.79999 11.6L9.19999 11.6ZM5.59999 1.20004L5.59999 10.8L2.79999 10.8C2.37564 10.8 1.96868 10.6315 1.66862 10.3314C1.36856 10.0313 1.19999 9.62438 1.19999 9.20004L1.19999 2.80004C1.19999 2.37569 1.36856 1.96872 1.66862 1.66867C1.96868 1.36861 2.37564 1.20004 2.79999 1.20004L5.59999 1.20004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeEditorResize);
export default __webpack_public_path__ + "static/media/CodeEditorResize.21f50a5de160e55c61a712ef2e47ba77.svg";
export { ForwardRef as ReactComponent };